import type { SubjectCode } from '~/models/Subject'
import type { ContentPackage } from '~/models/Content/ContentPackage'
import type { Task } from '~/models/AssignTask'
import type { ReportType } from '~/models/Assignment'
import { grades8to10 } from '~/utils/gradeSorter'
import { ContentType } from '~/models/Content/ContentType'

export const supportedSubjects: SubjectCode[] = ['ENG']
export const defaultSubject = supportedSubjects[0]
export const defaultMode: ReportType = 'exam'

export const currentYear = 2026
export const currentSeason = 'spring'

export const SHARE_TAG = 'share'
export const EXAM_TAG = `term-exam-${currentSeason}-${currentYear}`

export const isExamTask = (task: Task) => task.tags?.includes(EXAM_TAG) ?? false
export const getReportTag = (subjectCode: SubjectCode) => `term_exam_${currentSeason}_${currentYear}_${subjectCode.toLowerCase()}`

export const isFlexibleExam = (resource: ContentPackage) => 'subjects' in resource
  && resource.subjects?.includes('NOR')
  && resource.grades?.some(g => grades8to10.includes(g))
  && resource.parentLocationContentTypeIdentifier === ContentType.TermExam

export const isStaticExam = (resource: ContentPackage) => 'subjects' in resource
  && resource.subjects?.includes('MAT')
  && resource.grades?.some(g => grades8to10.includes(g))
